import Immutable from 'immutable'
import type { ShiftRecord } from 'libs/data-access/queries/src/lib/queries/Schedule/Shift/types/Shift.schema'
import moment from 'moment'

import {
  getDataByForeignId,
  getDataByForeignIds,
  getDataByForeignIdThroughOtherForeignId
} from '../../services/immutableUtils'

export const getIsShiftsLoading = state =>
  state.shifts.getIn(['meta', 'loading'])

export const getShiftById = (state, shiftId): ShiftRecord =>
  state.shifts.getIn(['data', shiftId])

export const getDashboardShiftsPerPage = (state, currentPage) =>
  state.shifts.getIn(['pagination', 'pages', currentPage], Immutable.Set())

export const getShiftsByWeeklyscheduleId = (state, wksId) =>
  getDataByForeignId(state, 'shifts', 'weeklyschedule_id', wksId)

export const getShiftsByWeeklyscheduleIds = (state, wksIds) =>
  getDataByForeignIds(state, 'shifts', 'weeklyschedule_id', wksIds)

export const getShiftsByContractId = (state, contractId) =>
  getDataByForeignId(state, 'shifts', 'user_contract_id', Number(contractId))

export const getShiftsByContractIds = (state, contractIds) =>
  getDataByForeignIds(
    state,
    'shifts',
    'user_contract_id',
    contractIds.map(i => Number(i))
  )

export const getShiftsByWeek = (state, week) =>
  getDataByForeignId(state, 'shifts', 'week', moment(week).format('GGGG-[W]WW'))

export const getShiftsThroughOtherForeignId = (state, membershipId) =>
  getDataByForeignIdThroughOtherForeignId(
    state,
    'shifts',
    'user_contract_id',
    'contracts',
    'membership_id',
    membershipId
  )
export const getShiftsByMembershipId = getShiftsThroughOtherForeignId
